export const createBreadcrumb = (label?: string, link?: string) => ({
  label: label || '',
  link,
});
